import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Axios from 'axios';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import omitBy from 'lodash/omitBy';
import every from 'lodash/every';
import { withRouter } from 'react-router';
import Toggle from 'react-toggle';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dialog from 'material-ui/Dialog';
import Loading from '../../../../components/Loading';
import { NoAccess, BaseButton, RowDivision, LoadingWrapper } from '../../../../styles/styled';
import styles from '../shared/styles';
import SingleEpisode from './SingleEpisode';
import BulkEpisode from './BulkEpisode';
import { ActionButton } from '../../../../components/buttons/buttons';
import { sendNotifications } from '../../../../helpers/send_notifications';
import { sendEpisodeEmailNotification } from '../../../../helpers/sendEmails';
import {
  authManager,
  basicManager,
  episodeManager,
  soundcastManager,
} from '../../../../helpers/managers';
import {
  getSoundcastsManagedv2,
  getSoundcastsManagedCountV2,
  getAllEpisodesCountV2,
  getHighestEpisodeIndex,
  hasUserExceededContentPlanLimit,
  canUserAccessFeature,
} from '../../../../helpers/userinfoHelper';
import { filterOutSoundcastBundles, getSoundcastItunesImageUrl } from '../../../../helpers/soundcasts';
import userTour from '../../../../helpers/tour';
import {
  isEpisodeScheduled,
  getFormattedSchedule,
  getEpisodeStatusState,
  episodeHasErrorStatusState,
  extractEpisodeStatusState,
} from '../../../../helpers/episodes';
import { ALERTS } from '../../../../helpers/texts';
import { getExactAudioWorkerRootHost } from '../../../../helpers/misc';
const { isSoundcastDripped } = require('../../../../../server/scripts/utils.js')();
const { loadSoundcastEpisodesMaxIndex } = require('./miscUtils.js');

class CreateEditEpisode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bulkupload: false,
      saving: false,
      empty: true,
      modal: {
        show: false,
        title: '',
        content: '',
        dismissible: true,
      },
      allowed: false,
      userPlan: '',
      soundcastsManaged: [],
    };

    this.highestEpisodeIndex = null;
    this.modalHandler = this.modalHandler.bind(this);
    this.hasExceededPlanLimit = this.hasExceededPlanLimit.bind(this);
    this.onBulkUpload = this.onBulkUpload.bind(this);
    this.realSaveEpisode = this.realSaveEpisode.bind(this);
    this.realUpdateEpisode = this.realUpdateEpisode.bind(this);
    this.deleteEpisode = this.deleteEpisode.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchSoundcastManaged(nextProps);
  }

  componentDidMount() {
    this.checkContentLimit();
    this.fetchSoundcastManaged();
  }

  checkContentLimit() {
    const { editmode } = this.props;
    // don't change allowed if already set
    this.setState(({ allowed }) => {
      return {
        allowed: allowed ? allowed : !hasUserExceededContentPlanLimit() || editmode,
      };
    });
  }

  fetchSoundcastManaged(props = {}) {
    // get soundcast_managed
    props = !isEmpty(props) ? props : this.props;
    const soundcastsManaged = getSoundcastsManagedv2();

    // // redirect back to soundcasts page if its loaded directly
    // // we can check if this episode is already loaded in state
    // if (!hasManagedEpisodes()) {
    //   return props.history.replace(`/dashboard/soundcasts`);
    // }

    if (!isEmpty(soundcastsManaged)) {
      this.setState({ soundcastsManaged }, () => {
        const soundcastsCount = getSoundcastsManagedCountV2();
        // add 1 as we are gonna access the add episode page for verification
        // this will verify if we're gonna exceed adding episode(s)
        const episodesCount = getAllEpisodesCountV2() + 1;
        if (this.hasExceededPlanLimit(soundcastsCount, episodesCount) && !props.editmode) {
          // update allowed state when exceeded, only when episode data is empty
          if (this.state.empty) {
            this.setState({
              allowed: false,
            });
          }
        }
      });
    }
  }

  hasExceededPlanLimit(soundcastsCount = 0, episodesCount = 0) {
    return hasUserExceededContentPlanLimit(soundcastsCount, episodesCount);
  }

  restrictAccess() {
    this.setState({
      strictmode: true,
    });
  }

  showModal(metadata) {
    this.modalHandler({
      show: true,
      ...metadata,
    })();
  }

  modalHandler(metadata = {}) {
    let {
      show = false,
      title = '',
      content = '',
      upgrade = false,
      onClose = false,
      dismissible = true,
    } = metadata;

    return () => {
      let { onClose: oldClose } = this.state.modal;
      this.setState(
        {
          modal: {
            ...this.state.modal,
            show,
            title,
            content,
            upgrade,
            dismissible,
            onClose: !show ? false : onClose,
          },
        },
        () => {
          if (oldClose && !show) {
            oldClose();
          }
        }
      );
    };
  }

  onBulkUpload() {
    // make sure that the user have access to the feature
    // too allow bulk uploading, otherwise
    // show them the pricing modal
    const noAccess = !canUserAccessFeature('EPISODE_BULKUPLOAD');
    const limitExceeded = this.hasExceededPlanLimit();
    const errored = noAccess || limitExceeded;
    if (errored) {
      this.restrictAccess();

      const content = noAccess
        ? ALERTS().EPISODE_BULKUPLOAD.NO_ACCESS
        : ALERTS().EPISODE_BULKUPLOAD.LIMIT_EXCEEDED;

      return this.showModal({
        title: 'Upgrade Required',
        content,
        upgrade: true,
        dismissible: false,
        onClose: () => this.props.history.push(`/dashboard/soundcasts`),
      });
    }

    this.setState(({ bulkupload }) => ({
      bulkupload: !bulkupload,
    }));
  }

  getFirebaseAuthUser() {
    return new Promise(resolve => {
      authManager.onAuthStateChanged(resolve);
    });
  }

  getAudioProcessingConfig(episode, soundcast) {
    const {
      episodeId,
      autoPublish,
      emailListeners = false,
      audioNormalization,
      trimSilence,
      reduceSilence,
      addIntroOutro,
      silentPeriod,
      overlayDuration,
    } = episode;

    const { soundcastId, introOutroOverlay, intro, outro } = soundcast;
    const options = omitBy(
      {
        intro: addIntroOutro && intro ? true : null,
        outro: addIntroOutro && outro ? true : null,
        tagging: true,
        overlayDuration:
          (addIntroOutro && (Number(overlayDuration) || Number(introOutroOverlay))) || 0,
        setVolume: audioNormalization,
        trim: trimSilence,
        removeSilence: (reduceSilence && Number(silentPeriod)) || 0,
      },
      isNull
    );

    return [
      `${getExactAudioWorkerRootHost()}/api/episode`,
      {
        episodeId,
        soundcastId,
        autoPublish,
        emailListeners,
        type: 'processing',
        options,
      },
    ];
  }

  getAudioProcessingReplaceConfig(episode, soundcast) {
    const { episodeId } = episode;
    const { soundcastId } = soundcast;

    return [
      `${getExactAudioWorkerRootHost()}/api/episode`,
      {
        episodeId,
        soundcastId,
        type: 'replace',
      },
    ];
  }

  deleteEpisode(episodeId, soundcastId) {
    this.setState({ saving: true }, () => {
      this.deleteEpisodeInternal(episodeId, soundcastId);
    });
  }

  deleteEpisodeInternal(episodeId, soundcastId) {
    // console.log('deleting episode', episodeId);
    return new Promise((mresolve, mreject) => {
      // delete the data from both firebase and postgres
      Axios.delete(`/api/soundcast/${soundcastId}/episode/${episodeId}`)
        .then(() => {
          this.setState({ saving: false, empty: true }, mresolve);
        })
        .catch(error => {
          this.setState({ saving: false }, () => {
            console.error('Error: There was a problem removing episode', error);
            mreject(error);
          });
        });
    });
  }

  realSaveEpisode(episode, soundcast) {
    return new Promise((resolve, reject) => {
      this.setState({ saving: true, empty: false }, async () => {
        try {
          const state = await this.saveEpisodeInternal(episode, soundcast);
          this.setState({ saving: false, ...(state || {}) }, resolve);
        } catch (err) {
          console.log('saveEpisodeFinal err', err);
          this.setState({ saving: false, empty: true }, () => reject(err));
        }
      });
    });
  }

  realUpdateEpisode(episode, soundcast, rePublish = false) {
    this.setState({ saving: true }, () => {
      this.updateEpisodeInternal(episode, soundcast, rePublish);
    });
  }

  saveEpisodeInternal(episode, soundcast) {
    return new Promise(async (mresolve, mreject) => {
      try {
        let {
          id: episodeId,
          index = null, // ??? 1
          title,
          description = '',
          actionstep = '',
          duration = 0,
          episodeUrl: url,
          notesUrl: notes = '',
          coverArtUrl = '',
          public: publicEpisode = false,
          isPublished = false,
          audioProcessing = false,
          isSingleEpisode = false,
          publishOn = null,
          releaseInterval = 0,
          emailListeners = false,
          complete: completeEpisode = false,
          finalsave = false,
          frombulk = false,
        } = episode;

        // do not save when required metadata are empty
        const requiredFieldsValid = every([!isEmpty(title), !isEmpty(url)], Boolean);
        if (!requiredFieldsValid) {
          return mresolve({ empty: true });
        }

        // ensure some limitations are applied
        audioProcessing = canUserAccessFeature('EPISODE_PROCESSING') ? audioProcessing : false;
        emailListeners = canUserAccessFeature('EMAIL_TO_LISTENERS') ? emailListeners : false;
        publishOn = canUserAccessFeature('EPISODE_SCHEDULED') ? publishOn : null;

        const {
          soundcastId,
          title: soundcastTitle,
          podcastFeedVersion = false,
          itunesExplicit,
          itunesCategory,
          itunesTitle,
          itunesHost,
          hostName,
        } = soundcast;

        const {
          userInfo,
          managed,
          addUpdateManagedSoundcastEpisode,
          updateSoundcastEpisodesOrderCreator,
        } = this.props;
        const firebaseUser = await this.getFirebaseAuthUser();
        const newEpisode = {
          index, // index here should still depend on existing episodes
          title,
          description,
          actionstep,
          date_created: moment().unix(),
          date_published: isPublished ? moment().unix() : null,
          creatorID: firebaseUser.uid,
          publisherID: userInfo.publisherID,
          ...(isEmpty(url) ? {} : { url }), // ???
          duration,
          notes,
          publicEpisode,
          soundcastID: soundcastId,
          isPublished,
          coverArtUrl,
          audioProcessing,
          publishOn,
          releaseInterval,
          emailListeners,
          last_update: moment().unix(),
        };

        // when episode duration is zero, check the firebase
        // if a duration was already set by the server
        // TODO: read this from api endpoint
        if (duration === 0 || isEmpty(duration)) {
          const nduration = await episodeManager.getProp(episodeId, 'duration', 0);
          if (nduration !== 0) {
            newEpisode.duration = nduration;
          }
        }

        // determine later publish
        const isLaterPublish = isEpisodeScheduled(episode);
        console.log('newEpisode', newEpisode);

        let episodeRequest = [
          // update episode on firebase
          new Promise( async (resolve, reject) => {
            /// console.log('newEpisode with index update', newEpisode);
            /// lets get the highest episode index and cache it #347
            /// a reason we have to this in here is because
            /// at this point we have the episodes details now in redux state
            // if (isNull(this.highestEpisodeIndex)) {
            //   const newIndex = getHighestEpisodeIndex(soundcastId);
            //   this.highestEpisodeIndex = newIndex + 1;
            // }

            if (isSingleEpisode) {
              if (isNull(newEpisode.index)) {
                newEpisode.index = await loadSoundcastEpisodesMaxIndex(soundcastId) + 1;
              }
            } else {
              if (isNull(this.highestEpisodeIndex)) {
                this.highestEpisodeIndex = await loadSoundcastEpisodesMaxIndex(soundcastId) + 1;
              }
              newEpisode.index += this.highestEpisodeIndex;
            }

            episodeManager.update(episodeId, newEpisode).then(resolve).catch(reject);
          }),
          // update soundcast props to firebase
          // includes last_update and lastEpisodeUpdate
          new Promise((resolve, reject) => {
            // if not complete do not save some soundcast related info yet
            if (!completeEpisode) {
              return resolve();
            }

            let status = isPublished ? 'published' : 'draft';

            // if its scheduled publish make it `scheduled`
            if (isLaterPublish) {
              status = 'scheduled';
            }

            basicManager
              .update({
                [`soundcasts/${soundcastId}/episodes/${episodeId}`]: status,
                [`soundcasts/${soundcastId}/last_update`]: newEpisode.date_created,
                [`soundcasts/${soundcastId}/lastEpisodeUpdate`]: newEpisode.date_created,
              })
              .then(resolve)
              .catch(reject);
          }),

          new Promise((resolve, reject) => {
            let execPublishEvent = isPublished;

            // if its scheduled publish exec event later
            if (isLaterPublish) {
              execPublishEvent = false;
            }

            // and postgresql
            Axios.post('/api/episode', {
              episodeId,
              ...newEpisode,
              execPublishEvent,
            })
              .then(resolve)
              .catch(reject);
          }),

          new Promise((resolve, reject) => {
            if (!isLaterPublish) {
              return resolve();
            }

            // schedule the episode publication
            Axios.post('/api/episode/schedule', {
              episodeId,
              soundcastId,
              publishOn,
            })
              .then(resolve)
              .catch(reject);
          }),
        ];

        // on final save, only include request for soundcast specific updates
        const publishing = isPublished || isLaterPublish;
        if (finalsave) {
          const soundcastRequest = [
            // update soundcast
            new Promise(async (resolve, reject) => {
              try {
                await Axios.post('/api/soundcast', {
                  soundcastId,
                  publisherId: userInfo.publisherID,
                  updateDate: newEpisode.date_created,
                });

                // update listeners delivery schedules when publishing
                if (publishing && isSoundcastDripped(soundcast)) {
                  const updateScheduleUrl = `/api/soundcast/${soundcastId}/episodes/delivery_update`;
                  await Axios.post(updateScheduleUrl);
                }

                resolve();
              } catch (err) {
                reject(err);
              }
            }),

            // create/update feed, only if publishing it now
            new Promise((resolve, reject) => {
              const shouldUpdateFeed = publishing && !isLaterPublish && podcastFeedVersion;
              if (!shouldUpdateFeed) {
                return resolve();
              }

              Axios.post('/api/create_feed', {
                soundcastId,
                itunesExplicit,
                itunesImage: getSoundcastItunesImageUrl(soundcast),
                itunesCategory,
                soundcastTitle: itunesTitle || soundcastTitle,
                soundcastHost: itunesHost || hostName,
                firstName: userInfo.firstName,
                email: userInfo.email[0],
              })
                .then(resolve)
                // .catch(reject)
                .catch(err => {
                  console.error(`ERROR: /api/create_feed errored -`, err.message);
                  resolve();
                });
            }),
          ];

          episodeRequest = [...episodeRequest, ...soundcastRequest];
        }

        // initial async request
        console.log('episodeRequest Create', episodeRequest);
        await Promise.all(episodeRequest);

        // push/update to redux tree
        const episodeState = await getEpisodeStatusState(episodeId);

        // only push to state tree when final episode meta has been decided
        if (completeEpisode) {
          addUpdateManagedSoundcastEpisode(soundcast, {
            episodeId,
            ...newEpisode,
            partialOpenChannelOnPublish: true,
          });

          // update episodes order on finalsave
          if (finalsave) {
            await updateSoundcastEpisodesOrderCreator({ soundcast, feedUpdate: false });
          }
        }

        // for final publication do the necessary actions
        // like handle audio processing and feed creations
        // as long as its not from bulk call
        if (finalsave && !frombulk) {
          // Retrieve episodeState (#131 issue)
          if (episodeHasErrorStatusState({ episodeState })) {
            this.showModal({
              content: `Processing error: ${extractEpisodeStatusState(episodeState)}`,
            });

            return mresolve();
          }

          // when the audioProcessing prop is set (episode-processing)
          if (audioProcessing) {
            this.saveEpisodeAudioProcessing(episode, soundcast, episodeState);
            return mresolve();
          }

          // when episode is in processing mode (after initial upload and currently being converted to mp3)
          if (isPublished && episodeState === `processing`) {
            const { subscribed = {} } = soundcast || {};
            const subscribers = {
              ...(subscribed || {}),
              ...(await soundcastManager.getSubscribedObj(soundcastId) || {}),
            };
            soundcast.subscribed = subscribers;
            const subscribersIds = Object.entries(subscribers)
              .filter(([, value]) => value !== false && value !== null)
              .map(([key]) => key);
            if (emailListeners && !isEmpty(subscribersIds)) {
              await episodeManager.saveProp(episodeId, 'sendNotificationsAfterUploading', true);
            }
            this.redirectToSoundcastPage(soundcastId, true, isPublished);
            return mresolve();
          }

          // set user tour prop
          if (userTour.available()) {
            userTour.setUserProp('createdEpisode', true);
          }

          // notify the subscribers respectively
          // its here because bulk episodes should not notify users multiple times
          if (isPublished || isLaterPublish) {
            // notify subscribers only if not to be publish later
            // and not drip soundcast (with releaseInterval > 0)
            const drippedEpisode = isSoundcastDripped(soundcast) && releaseInterval > 0;
            if (!isLaterPublish && !drippedEpisode) {
              this.notifySubscribers(episode, soundcast, {
                data: {
                  type: 'NEW_EPISODE',
                  episodeId,
                  soundcastId,
                },
              });
            }

            // show alert message
            const content = !isLaterPublish
              ? 'Track has been successfully published.'
              : `Track will be published on ${getFormattedSchedule(publishOn)}`;

            this.showModal({
              content,
              onClose: () => {
                this.props.history.push(`/dashboard/soundcast/${soundcastId}`);
              },
            });

            return mresolve();
          }

          // or redirect back to soundcast page
          this.redirectToSoundcastPage(soundcastId);
        }

        mresolve();
      } catch (err) {
        console.log('saveEpisodeInternal err', err);
        mreject(err);
      }
    });
  }

  async updateEpisodeInternal(episode, soundcast, rePublish = false) {
    const { userInfo, history, addUpdateManagedSoundcastEpisode } = this.props;
    const {
      episodeId,
      willPublish,
      redoProcessing,
      isPublishedOld,
      isLaterPublishOld,
      audioNormalization,
      trimSilence,
      reduceSilence,
      addIntroOutro,
      episodeUrl: url,
      silentPeriod,
      overlayDuration,
      emailListeners = false,
      finalupdate = false,
      ...editedEpisode
    } = episode;

    const {
      soundcastId,
      itunesCategory,
      itunesExplicit,
      podcastFeedVersion,
    } = soundcast;

    // determine later publish
    const isLaterPublish = isEpisodeScheduled(episode);

    // update soundcastId if change
    try {
      let firstPublication = false;

      const oldEpisode = await episodeManager.getById(episodeId);
      if (isEmpty(oldEpisode)) {
        throw new Error('Track does not exist');
      }

      const oldSoundcastID = oldEpisode.soundcastID;
      const updatedEpisode = { ...oldEpisode, ...editedEpisode, emailListeners };

      // add the episodes `date_published` for the very first time
      // only happens when coming from draft state -> publish state
      // or the property is of course not initialized
      const { date_published: oldDatePublished = null } = updatedEpisode;
      if ((willPublish && !oldDatePublished) || rePublish) {
        updatedEpisode.date_published = moment().unix();

        // mark first publication if never been published
        if (!isPublishedOld) {
          firstPublication = true;
        }
      }

      // if redoing a process, mark the `audioProcessing` too
      updatedEpisode.audioProcessing = redoProcessing;

      // update the episode in firebase
      await episodeManager.save(episodeId, updatedEpisode);

      // edit episode in database
      if (oldSoundcastID !== soundcastId) {
        await basicManager
          .update({
            [`soundcasts/${oldSoundcastID}/episodes/${episodeId}`]: null,
            [`soundcasts/${soundcastId}/episodes/${episodeId}`]: true,
          });
      }

      // start other episode requests
      let episodeRequest = [
        new Promise(async (resolve, reject) => {
          try {
            // execPublishEvent is when coming from draft staate to publish
            let execPublishEvent = !isPublishedOld && willPublish ? true : false;

            // if its scheduled publish exec event later
            if (isLaterPublish) {
              execPublishEvent = false;
            }

            await Axios.post('/api/episode', {
              episodeId,
              ...updatedEpisode,
              execPublishEvent,
            });

            resolve();
          } catch (err) {
            reject(err);
          }
        }),
      ];

      // on final update, include specific updates
      if (finalupdate) {
        episodeRequest = [
          ...episodeRequest,

          // update episode schedule if any
          new Promise(async (resolve, reject) => {
            try {
              if (isLaterPublish || isLaterPublishOld) {
                // schedule the episode publication
                const schedule = {
                  episodeId,
                  soundcastId,
                  publishOn: updatedEpisode.publishOn,
                };

                if (!isLaterPublish && isLaterPublishOld) {
                  schedule.revoke = true;
                }

                await Axios.post('/api/episode/schedule', schedule);
              }

              resolve();
            } catch (err) {
              reject(err);
            }
          }),

          // update delivery schedules when soundcast is dripped
          new Promise(async (resolve, reject) => {
            try {
              if (!isSoundcastDripped(soundcast) || isLaterPublish) {
                return resolve();
              }

              // update listeners delivery schedules when set draft after published or set published after draft
              if ((isPublishedOld && !willPublish) || (!isPublishedOld && willPublish)) {
                const updateScheduleUrl = `/api/soundcast/${soundcastId}/episodes/delivery_update`;
                await Axios.post(updateScheduleUrl);
              }

              resolve();
            } catch (err) {
              reject(err);
            }
          }),

          // update soundcast props to firebase
          // includes last_update and lastEpisodeUpdate
          new Promise(async (resolve, reject) => {
            try {
              let status = willPublish ? 'published' : 'draft';

              // if its scheduled publish make it `scheduled`
              if (isLaterPublish) {
                status = 'scheduled';
              }

              const currentTime = moment().unix();
              await basicManager
                .update({
                  [`soundcasts/${soundcastId}/episodes/${episodeId}`]: status,
                  [`soundcasts/${soundcastId}/last_update`]: currentTime,
                  [`soundcasts/${soundcastId}/lastEpisodeUpdate`]: currentTime,
                });

              resolve();
            } catch (err) {
              reject(err);
            }
          }),

          // update feed, only if publishing it now
          new Promise(async (resolve, reject) => {
            if (!podcastFeedVersion) {
              return resolve();
            }

            try {
              await episodeManager.saveProp(episodeId, 'id3Tagged', false);

              // update soundcast info
              await Axios.post('/api/create_feed', {
                soundcastId,
                itunesExplicit,
                itunesImage: getSoundcastItunesImageUrl(soundcast),
                itunesCategory,
                email: userInfo.publisher.email,
                firstName: userInfo.firstName,
              });

              resolve();
            } catch (err) {
              console.error(`ERROR: /api/create_feed errored -`, err.message);
              // reject(err);
              resolve();
            }
          }),
        ];
      }

      // update async request
      console.log('episodeRequest Update', episodeRequest);
      await Promise.all(episodeRequest);

      if (isEmpty(updatedEpisode.url)) {
        updatedEpisode.url = await episodeManager.getProp(episodeId, 'url', '');
      }

      // update the redux tree
      addUpdateManagedSoundcastEpisode(soundcast, {
        episodeId,
        ...updatedEpisode,
        partialOpenChannelOnPublish: finalupdate,
      });

      // update on finalupdate
      if (finalupdate) {
        // determines if the episode has an edited or processed audio
        // that is ready to be replaced once published
        const hasProcessedAudio = !isEmpty(updatedEpisode.editedUrl);

        // Draft state -> Publish state
        // console.log('isPublishedOld', isPublishedOld, willPublish);
        if (!isPublishedOld) {
          // redo the audio processing if set, and the `willPublish`
          // will decide wether to publish the episode or not
          // this happens on the server
          if (redoProcessing) {
            // console.log('Redoing processing from publish state...', willPublish);
            let optionsError = '';
            if (Number(overlayDuration) < 0.1 || Number(overlayDuration) > 10) {
              optionsError =
                'Overlap with main audio: Please enter a number greater than or equal to 0.1 and less than or equal to 10.';
            } else if (Number(silentPeriod) < 0.1 || Number(silentPeriod) > 10) {
              optionsError =
                'Remove excessive pauses: Please enter a number greater than or equal to 0.1 and less than or equal to 10.';
            }

            if (!isEmpty(optionsError)) {
              return this.setState({ saving: false }, () => {
                this.showModal({
                  title: 'Audio Processing',
                  content: optionsError,
                });
              });
            }

            return await new Promise(async resolve => {
              try {
                const audioProcessingConfig = this.getAudioProcessingConfig(
                  { ...episode, autoPublish: willPublish },
                  soundcast
                );

                await Axios.post(...audioProcessingConfig);
                this.showModal({
                  content:
                    "Processing request is submitted. We'll email you when processing is complete.",
                  onClose: () => history.push(`/dashboard/soundcast/${soundcastId}`),
                });
              } catch (err) {
                console.log('There was a problem processing episode', err.message);
                this.showModal({
                  content:
                    'There was a problem when processing the track, please contact support if persist.',
                });
              } finally {
                resolve();
              }
            });
          }

          // if no audio processing is involved
          // if an `editUrl` is present publish the episode
          // by replaceing the episode `url` with `editUrl`
          // this means that the user is already satisfied
          // with the processed audio
          if ((willPublish || isLaterPublish) && hasProcessedAudio) {
            // console.log('updatedEpisode.editedUrl', updatedEpisode.editedUrl);
            const processingConfig = this.getAudioProcessingReplaceConfig(episode, soundcast);
            await Axios.post(...processingConfig);
          }
        }

        // notify the subscribers only if never been published
        // only if there are no processed audio (will notify them via audio worker)
        if (firstPublication && !hasProcessedAudio) {
          // console.log('firstPublication notifying users');
          this.notifySubscribers({ ...episode, id: episodeId }, soundcast);
        }

        this.showModal({
          content: 'Track has been updated successfully',
          onClose: () => history.push(`/dashboard/soundcast/${soundcastId}`),
        });
      }
    } catch (e) {
      console.log('There was a problem updating episode', episodeId, e.message);
      this.showModal({
        content:
          `There was a problem when updating the track ${episodeId}, ` +
          `please contact support at support@mysoundwise.com if the issue persists.`,
      });
    } finally {
      this.setState({ saving: false });
    }
  }

  redirectToSoundcastPage(soundcastId, showAlert, isPublished) {
    if (showAlert) {
      const content = isPublished
        ? 'Track is submitted and will be published after audio processing is done.'
        : 'Track is saved. We will notify you by email when audio processing is done.';

      return this.showModal({
        content,
        onClose: () => {
          this.props.history.push(`/dashboard/soundcast/${soundcastId}`);
        },
      });
    }

    // disable saving state, for unload component
    this.setState({ saving: false }, () => {
      this.props.history.push(`/dashboard/soundcast/${soundcastId}`);
    });
  }

  notifySubscribers(episode, soundcast, payload = {}) {
    const { title: soundcastTitle, subscribed = {} } = soundcast;
    const { id: episodeId, title: episodeTitle, emailListeners = false } = episode;
    if (!isEmpty(subscribed)) {
      let registrationTokens = [];
      const subscribers = subscribed;
      Object.keys(subscribers).forEach(user => {
        if (typeof subscribers[user] === 'object') {
          if (typeof subscribers[user][0] === 'string') {
            registrationTokens.push(subscribers[user][0]);
          }
        }
      });

      // console.log('Notify subscribers', registrationTokens);
      if (!isEmpty(registrationTokens)) {
        sendNotifications(registrationTokens, {
          notification: {
            title: `${soundcastTitle} just published:`,
            body: episodeTitle,
            sound: 'default',
            badge: '1',
          },
          ...payload,
        }); // send push notification
      }
    }

    if (emailListeners && canUserAccessFeature('EMAIL_TO_LISTENERS')) {
      sendEpisodeEmailNotification(episodeId);
    }
  }

  async saveEpisodeAudioProcessing(episode, soundcast, episodeState) {
    const { id: episodeId, isPublished = false, silentPeriod, overlayDuration } = episode;

    // if audio processing is requested
    if (Number(overlayDuration) < 0.1 && Number(overlayDuration) > 10) {
      return this.showModal({
        content: 'Overlap with main audio: Please enter a number >=0.1 and <= 10.',
      });
    }
    if (Number(silentPeriod) < 0.1 && Number(silentPeriod) > 10) {
      return this.showModal({
        content: 'Remove excessive pauses: Please enter a number >=0.1 and <= 10.',
      });
    }

    // determine the processing url and options
    // for now use the new audio worker for processing if dummy account
    const [processingUrl, processingOptions] = this.getAudioProcessingConfig(
      {
        ...episode,
        episodeId,
        autoPublish: isPublished,
      },
      soundcast
    );

    // currently processing
    if (episodeState === 'processing') {
      await episodeManager.saveProp(episodeId, 'processingOptions', processingOptions);
    } else {
      await Axios.post(processingUrl, processingOptions);
    }

    this.redirectToSoundcastPage(soundcast.soundcastId, true, isPublished);
  }

  renderModal() {
    const { show, title, content, upgrade, dismissible = true, onClose } = this.state.modal;
    const actionLabel = upgrade ? 'Upgrade' : 'OK';
    const actionBtnClick = upgrade
      ? () => this.props.history.push('/pricing')
      : this.modalHandler({ show: false });
    const actions = [
      <div style={{ textAlign: 'center', padding: 20 }}>
        <ActionButton id="actionButtonTest1" onClick={actionBtnClick}>
          {actionLabel}
        </ActionButton>
        {upgrade && (
          <ActionButton
            textColor="#f76b1c"
            backgroundColor="#fff"
            onClick={() => {
              this.modalHandler({ show: false })();
              if (onClose) {
                onClose();
              }
            }}>
            Cancel
          </ActionButton>
        )}
      </div>,
    ];

    return (
      <Dialog
        title={
          <div className="title-medium" style={{ fontWeight: 800, textAlign: 'center' }}>
            {title}
          </div>
        }
        actions={actions}
        modal={!dismissible}
        open={show}
        onRequestClose={this.modalHandler({ show: false })}>
        <div className="title-small" style={{ textAlign: 'center', padding: '0 20px' }}>
          {content}
        </div>
      </Dialog>
    );
  }

  renderHeader() {
    const { isLoggedIn, editmode } = this.props;
    const singleEpisodeAddTxt = !editmode ? 'Add A New Track' : 'Edit Track';
    const mainTitle = this.state.bulkupload ? 'Add New Tracks' : singleEpisodeAddTxt;

    if (this.state.strictmode) {
      return null;
    }

    return (
      <div className="padding-bottom-20px padding-top-20px">
        <div className="row">
          <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
            <div style={styles.topHeaderSwitcher}>
              <div className="title-medium">{mainTitle}</div>
              {isLoggedIn && !editmode && (
                <div id="bulk-upload-btn" style={styles.toggleWrapper}>
                  <Toggle
                    className="toggle-green"
                    id="bulk-upload"
                    aria-labelledby="share-label"
                    checked={this.state.bulkupload}
                    onChange={this.onBulkUpload}
                    disabled={isEmpty(this.state.soundcastsManaged)}
                  />
                  <span
                    id="share-label"
                    style={{ fontSize: 16, fontWeight: 800, marginLeft: '0.5em' }}>
                    Bulk Upload
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderBody() {
    const { bulkupload, userPlan, soundcastsManaged, strictmode } = this.state;
    const commonProps = {
      realSaveEpisode: this.realSaveEpisode,
      realUpdateEpisode: this.realUpdateEpisode,
      onDeleteEpisode: this.deleteEpisode,
      saving: this.state.saving,
      modalHandler: this.modalHandler,
      hasExceededPlanLimit: this.hasExceededPlanLimit,
      editmode: this.props.editmode,
      soundcastsManaged: filterOutSoundcastBundles(soundcastsManaged),
      userPlan,
    };

    if (strictmode) {
      return null;
    }

    if (bulkupload) {
      return <BulkEpisode {...commonProps} {...this.props} />;
    }

    return <SingleEpisode {...commonProps} {...this.props} />;
  }

  render() {
    const { soundcastsManaged, allowed } = this.state;
    if (isEmpty(soundcastsManaged)) {
      return (
        <RowDivision className="row">
          <LoadingWrapper height="90">
            <Loading text="Verifying user, please wait" />
          </LoadingWrapper>
        </RowDivision>
      );
    }

    if (!allowed) {
      return (
        <NoAccess>
          <div className="upgrade padding-five sm-padding-ten sm-width-90 xs-width-100 bg-white">
            <div className="title-medium sm-title-medium xs-title-medium font-weight-600 margin-five-bottom">
              Upgrade to create more tracks
            </div>
            <div className="text-large sm-text-large line-height-26 margin-five-bottom">
              {ALERTS().ALLOWED_EPISODES.LIMIT_EXCEEDED}
            </div>
            <BaseButton onClick={() => this.props.history.push('/pricing')}>UPGRADE</BaseButton>
          </div>
        </NoAccess>
      );
    }

    return (
      <MuiThemeProvider>
        <React.Fragment>
          {this.renderHeader()}
          {this.renderBody()}
          {this.renderModal()}
        </React.Fragment>
      </MuiThemeProvider>
    );
  }
}

CreateEditEpisode.propTypes = {
  userInfo: PropTypes.object,
  history: PropTypes.object,
  isLoggedIn: PropTypes.any,
  editmode: PropTypes.bool,
};

CreateEditEpisode.defaultProps = {
  userInfo: {},
  history: {},
  isLoggedIn: false,
  editmode: false,
};

const createEditEpisode = withRouter(CreateEditEpisode);
export default createEditEpisode;
